import React from 'react';

const AnimeMascot: React.FC = () => (
  <svg viewBox="0 0 200 220" width="180" height="200">
    {/* body */}
    <ellipse cx="100" cy="175" rx="42" ry="38" fill="#7c4dff" opacity="0.9" />
    <ellipse cx="88" cy="165" rx="18" ry="14" fill="#9d7aff" opacity="0.4" />

    {/* head */}
    <circle cx="100" cy="95" r="52" fill="#fdd8c8" />

    {/* hair back */}
    <ellipse cx="100" cy="65" rx="56" ry="42" fill="#2d1b69" />
    <ellipse cx="58" cy="90" rx="14" ry="28" fill="#2d1b69" />
    <ellipse cx="142" cy="90" rx="14" ry="28" fill="#2d1b69" />

    {/* hair front bangs */}
    <path
      d="M52 75 Q65 42 100 48 Q135 42 148 75 Q140 58 120 55 Q108 62 100 56 Q92 62 80 55 Q60 58 52 75z"
      fill="#3b2080"
    />

    {/* face blush */}
    <ellipse cx="72" cy="108" rx="10" ry="6" fill="#ff8a9e" opacity="0.35" />
    <ellipse cx="128" cy="108" rx="10" ry="6" fill="#ff8a9e" opacity="0.35" />

    {/* eyes */}
    <ellipse cx="80" cy="98" rx="12" ry="14" fill="#2d1b69" />
    <ellipse cx="120" cy="98" rx="12" ry="14" fill="#2d1b69" />
    <circle cx="85" cy="93" r="5" fill="#fff" />
    <circle cx="125" cy="93" r="5" fill="#fff" />
    <circle cx="77" cy="100" r="2.5" fill="#fff" opacity="0.7" />
    <circle cx="117" cy="100" r="2.5" fill="#fff" opacity="0.7" />
    <ellipse cx="80" cy="100" rx="7" ry="8" fill="#7c4dff" opacity="0.3" />
    <ellipse cx="120" cy="100" rx="7" ry="8" fill="#7c4dff" opacity="0.3" />

    {/* mouth */}
    <path
      d="M93 114 Q100 120 107 114"
      fill="none"
      stroke="#c97878"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* arms */}
    <ellipse cx="68" cy="168" rx="12" ry="8" fill="#fdd8c8" />
    <ellipse cx="132" cy="168" rx="12" ry="8" fill="#fdd8c8" />

    {/* phone */}
    <rect x="82" y="155" width="36" height="24" rx="4" fill="#1a1a2e" />
    <rect x="85" y="158" width="30" height="18" rx="2" fill="#7c4dff" opacity="0.3" />
    <rect x="87" y="160" width="16" height="4" rx="2" fill="#fff" opacity="0.6" />
    <rect x="92" y="166" width="20" height="4" rx="2" fill="#ff4081" opacity="0.5" />

    {/* hair clip */}
    <circle cx="60" cy="72" r="5" fill="#ff4081" />
    <circle cx="60" cy="72" r="2" fill="#fff" opacity="0.5" />
  </svg>
);

export default AnimeMascot;
